'use client';

export default function ProjectTitleSkeleton() {
  return (
    <div className="flex items-end animate-pulse space-x-2">
      <div className="w-60 h-8 bg-gray-300 rounded-md" />
      <div className="w-6 h-6 bg-gray-300 rounded-md" />
      <div className="w-6 h-6 bg-gray-300 rounded-md" />
      <div className="w-6 h-6 bg-gray-300 rounded-md" />
    </div>
  );
}
